import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { ToastrService } from 'ngx-toastr';
import { VerificaEmail } from 'src/app/components/helper/form-validators/verifica-email';
import { QuizStepEnum } from 'src/app/api/module/erp/shared/enumerable/quiz-estilo-de-vida-step.enum';
import { QuizEstiloDeVidaCategoriaEnum, QuizEstiloDeVidaCategoriaEnumDescription } from 'src/app/api/module/erp/shared/enumerable/quiz-estilo-de-vida-categoria.enum';
import { QuizEstiloDeVidaRespostaEnumDescription } from 'src/app/api/module/erp/shared/enumerable/quiz-estilo-de-vida-resposta.enum';
import { ScrollService } from 'src/app/components/helper/service/scroll/scroll.service';
import { QuizEstiloDeVidaService } from 'src/app/api/module/externo/services/quiz-estilo-de-vida/quiz-estilo-de-vida.service';
import { DadosQuizEstiloDeVidaService } from 'src/app/api/module/externo/services/quiz-estilo-de-vida/dados-quiz-estilo-de-vida.service';

@Component({
  selector: 'app-quiz-estilo-de-vida',
  templateUrl: './quiz-estilo-de-vida.component.html',
  styleUrls: ['./quiz-estilo-de-vida.component.scss']
})
export class QuizEstiloDeVidaComponent implements OnInit {

  @ViewChild('stepper') set matStepper(stepper: MatStepper) {
    this.stepper = stepper;
    this.atualizarStepper(); // Atualiza o step quando o stepper estiver pronto
  }

  stepper!: MatStepper;
  isLinear: boolean = false;
  quizEstiloDeVidaEnum = QuizStepEnum;
  formQuiz!: FormGroup;
  isFormSubmited: boolean = false;
  formTouched: boolean = false;
  errorMessage: boolean = false;
  stepAtual: QuizStepEnum = QuizStepEnum.CADASTRO;
  currentQuestionIndex: number = 0;
  listaDePerguntas = new Array<any>();
  perguntasPorCategoria = new Array<any>();
  listaResposta = new Array<any>();
  categoriaAtual!: QuizEstiloDeVidaCategoriaEnum;
  mensagemCategoria: Array<{ texto: string, categoria: string, cor: string }> = [];
  idUsuario!: string;
  listaControlePerguntas: Array<{ categoria: string, perguntas: {} }> = [];
  ehOrientacao: boolean = false;
  mensagemResultado: Array<{ corTexto: string, corFundo: string, mensagem: string, img: string }> = [];
  grafico = new Array<any>();
  orientacao = new Array<any>();


  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private _scrollService: ScrollService,
    private _quizEstiloDeVidaService: QuizEstiloDeVidaService,
    private _dadosQuizEstiloDeVidaService: DadosQuizEstiloDeVidaService,
  ) { }

  ngOnInit(): void {
    this.criarFormularioQuiz();
    this.buscarOrientacaoQuiz();
  }

  criarFormularioQuiz() {
    this.formQuiz = this.formBuilder.group({
      name: new FormControl(null, [Validators.required]),
      email: new FormControl(null, [Validators.required,
      Validators.email,
      Validators.minLength(2),
      Validators.maxLength(250),
      Validators.required,
        VerificaEmail]),
      phone: new FormControl(null),
      response: new FormControl(null)
    })
  }

  buscarPerguntas(dados: any) {
    let perguntas = dados

    try {
      this.listaDePerguntas = perguntas
      this.perguntasPorCategoria = perguntas[0].questions;
      this.categoriaAtual = perguntas[0].order;
      this.onCategoria();
      this.listaResposta = QuizEstiloDeVidaRespostaEnumDescription.getAll();
      this.listaDePerguntas.forEach((item: any) => {
        const resposta = item.questions.map((pergunta: any) => {
          return {
            ordemDaPergunta: pergunta.order,
            resposta: pergunta.response
          };
        });

        this.listaControlePerguntas.push({
          categoria: item.order,
          perguntas: resposta
        });
      });
    } catch (error) {
      console.error(error);
      console.error("Perguntas não foram carregadas.")
    }
  }

  buscarOrientacaoQuiz() {
    this._dadosQuizEstiloDeVidaService.orientacao().subscribe({
      next: data => {
        this.orientacao = data && data;
      },
      error: err => {
        console.log(err)
      }
    }

    )
  }

  gotoTop() {
    this._scrollService.scrollToElement('#top-form', 140);
    this._scrollService.setStyle('#top-form', {
      'margin-top': '-141px !important',
    });
  }

  onOrientacao(valor: boolean): boolean {
    this.gotoTop();
    return this.ehOrientacao = valor;
  }

  onCategoria() {
    this.mensagemCategoria = [];

    switch (this.categoriaAtual) {
      case QuizEstiloDeVidaCategoriaEnum.ALIMENTACAO:
        this.mensagemCategoria.push({
          texto: 'Vamos falar sobre a sua ',
          categoria: QuizEstiloDeVidaCategoriaEnumDescription.getDescricao(QuizEstiloDeVidaCategoriaEnum.ALIMENTACAO),
          cor: '#F9AB41'
        });
        break;
      case QuizEstiloDeVidaCategoriaEnum.ATIVIDADE_FISICA:
        this.mensagemCategoria.push({
          texto: 'Me conte um pouco como está a sua ',
          categoria: QuizEstiloDeVidaCategoriaEnumDescription.getDescricao(QuizEstiloDeVidaCategoriaEnum.ATIVIDADE_FISICA),
          cor: '#80DC79'
        });
        break;
      case QuizEstiloDeVidaCategoriaEnum.COMPORTAMENTO_POSITIVO:
        this.mensagemCategoria.push({
          texto: 'Agora me fale sobre o seu ',
          categoria: QuizEstiloDeVidaCategoriaEnumDescription.getDescricao(QuizEstiloDeVidaCategoriaEnum.COMPORTAMENTO_POSITIVO),
          cor: '#79DCD9'
        });
        break;
      case QuizEstiloDeVidaCategoriaEnum.RELACIONAMENTOS:
        this.mensagemCategoria.push({
          texto: 'Vamos falar sobre ',
          categoria: QuizEstiloDeVidaCategoriaEnumDescription.getDescricao(QuizEstiloDeVidaCategoriaEnum.RELACIONAMENTOS),
          cor: '#DB79DC'
        });
        break;
      case QuizEstiloDeVidaCategoriaEnum.CONTROLE_DE_ESTRESSE:
        this.mensagemCategoria.push({
          texto: 'Para finalizar como está o seu ',
          categoria: QuizEstiloDeVidaCategoriaEnumDescription.getDescricao(QuizEstiloDeVidaCategoriaEnum.CONTROLE_DE_ESTRESSE),
          cor: '#ECD954'
        });
        break;
    }
  }

  onFieldChange() {
    if (this.formTouched) {
      this.errorMessage = !this.isFormValid();
    }
  }

  isFormValid() {
    this.isFormSubmited = true;
    return this.formQuiz.valid;
  }

  //Controle de Step
  redirecionamentoDeStep() {
    this.gotoTop();

    if (!this.stepper) return;

    const currentStepEnum = this.getIndexEnumDoStep(this.stepper.selectedIndex);
    switch (currentStepEnum) {
      case QuizStepEnum.CADASTRO:
        this.stepAtual = QuizStepEnum.PERGUNTAS;
        break;

      case QuizStepEnum.PERGUNTAS:
        this.stepAtual = QuizStepEnum.RESULTADO;
        break;
    }

    this.stepper.selectedIndex = this.getStepIndexFromEnum(this.stepAtual);
  }

  getStepIndexFromEnum(enumValue: number): number {
    const stepsOrder = [
      QuizStepEnum.CADASTRO,
      QuizStepEnum.PERGUNTAS,
      QuizStepEnum.RESULTADO,
    ];
    return stepsOrder.indexOf(enumValue);
  }

  getIndexEnumDoStep(stepIndex: number): QuizStepEnum {
    const stepsOrder = [
      QuizStepEnum.CADASTRO,
      QuizStepEnum.PERGUNTAS,
      QuizStepEnum.RESULTADO,
    ];
    return stepsOrder[stepIndex];
  }

  atualizarStepper() {
    setTimeout(() => {
      if (this.stepper) {
        this.stepper.selectedIndex = this.getStepIndexFromEnum(this.stepAtual);
      }
    });
  }

  verificaCategoria(perguntaAtual: any, respostaAtual: any) {
    //Preenche a resposta da pergunta atual
    this.listaControlePerguntas.forEach((item: any) => {
      item.perguntas.forEach((pergunta: any) => {
        if (pergunta.ordemDaPergunta == perguntaAtual.order) pergunta.resposta = respostaAtual;
      })
    })

    //Verifica se todas as resposta da categoria atual estão preenchidas
    const categoriaAtualItem = this.listaControlePerguntas.find((item: any) => item.categoria === this.categoriaAtual);

    if (categoriaAtualItem && Array.isArray(categoriaAtualItem.perguntas)) {
      const categoriaAtualRespondida = categoriaAtualItem.perguntas.every(
        (pergunta: any) => pergunta.resposta !== null && pergunta.resposta !== undefined
      );

      if (categoriaAtualRespondida) {
        // Encontra o índice da categoria atual
        const indexAtual = this.listaDePerguntas.findIndex((categoria: any) => categoria.order === this.categoriaAtual);
        const proximaCategoria = this.listaDePerguntas[indexAtual + 1];

        if (proximaCategoria) {
          this.perguntasPorCategoria = proximaCategoria.questions;
          this.categoriaAtual = proximaCategoria.order;
          this.onCategoria();
          this.gotoTop();
          this.formQuiz.reset();
        } else {
          // Todas as categorias respondidas
          const todasRespondidas = categoriaAtualItem.perguntas.every(
            (pergunta: any) => pergunta.resposta !== null && pergunta.resposta !== undefined
          );

          if (todasRespondidas) {
            this._quizEstiloDeVidaService.finalizarQuiz(this.idUsuario).subscribe({
              next: data => {
                this.onResultado(
                  data.score,
                  data.nutritionScore,
                  data.physicalActivityScore,
                  data.positiveBehaviorScore,
                  data.relationshipsScore,
                  data.stressControlScore
                );
                this.stepAtual = data.step as QuizStepEnum;
                this.redirecionamentoDeStep();
              }
            })
          }
        }
      }
    }
  }

  onChangeRespostaQuiz(event: Event, item: any) {
    let dadosParaEnviar = null;
    let respostaDoQuiz = event;
    let perguntaAtual = item;

    if (respostaDoQuiz !== null && respostaDoQuiz !== undefined && perguntaAtual) {
      dadosParaEnviar = {
        lifestyleQuizQuestionId: perguntaAtual.lifestyleQuizQuestionId,
        lifestyleQuizPersonalDataId: this.idUsuario,
        response: respostaDoQuiz
      }

      this._quizEstiloDeVidaService.responderQuiz(dadosParaEnviar).subscribe({
        next: data => {
          this.verificaCategoria(perguntaAtual, respostaDoQuiz)
        },
        error: err => {
          console.error(err)
        }
      })
    }
  }

  get progressoPercentual(): number {
    return this.categoriaAtual * 20;
  }


  onCadastrar() {
    this.formTouched = true;

    if (!this.isFormValid()) {
      this.errorMessage = true;
      this.isFormSubmited = true;
      return;
    }

    try {
      let dadosUsuario = {
        name: this.formQuiz.controls["name"].value,
        phone: this.formQuiz.controls["phone"].value,
        email: this.formQuiz.controls["email"].value,
      }

      this._quizEstiloDeVidaService.iniciarQuiz(dadosUsuario).subscribe({
        next: data => {
          let perguntasRecebidas = data && data[0];

          if (perguntasRecebidas.step) {
            this.idUsuario = perguntasRecebidas.id;
            this.stepAtual = perguntasRecebidas.step as QuizStepEnum;
            this.redirecionamentoDeStep();
            this.buscarPerguntas(perguntasRecebidas.questions);
            perguntasRecebidas.questions.forEach((item: any) => {
              item.questions.forEach((pergunta: any) => {
                if (pergunta.response) {
                  this.verificaCategoria(pergunta, pergunta.response)
                }
              })
            })

          } else {
            let resultado = data[0].returnDTO
            this.onResultado(
              resultado.score,
              resultado.nutritionScore,
              resultado.physicalActivityScore,
              resultado.positiveBehaviorScore,
              resultado.relationshipsScore,
              resultado.stressControlScore
            );

            this.stepAtual = resultado.step as QuizStepEnum;
            this.atualizarStepper();
          }
        }, error: error => {
          console.error(error)
        }
      })
    } catch (error) {
      this.toastr.error("Ocorreu um erro ao processar os seus dados")
    }

    return
  }

  onResultado(
    valorTotal: number,
    valorAlimentacao: number,
    valorAtividadeFisica: number,
    valorComportamentoPositivo: number,
    valorRelacionamentos: number,
    valorControleEstresse: number
  ) {
    this.gotoTop();
    this.mensagemResultado = [];
    this.grafico = [];


    this._dadosQuizEstiloDeVidaService.grafico(
      valorAlimentacao,
      valorAtividadeFisica,
      valorComportamentoPositivo,
      valorRelacionamentos,
      valorControleEstresse
    ).subscribe({
      next: data => {
        this.grafico = data && data
      },
      error: err => {
        console.log(err)
      }
    })

    this._dadosQuizEstiloDeVidaService.mensagemResultado().subscribe({
      next: data => {
        if (valorTotal <= 15) {
          //ruim
          this.mensagemResultado.push(data[0])
        } else if (valorTotal >= 16 && valorTotal <= 30) {
          //intermediario
          this.mensagemResultado.push(data[1])
        } else {
          //bom
          this.mensagemResultado.push(data[2])
        }
      }, error: err => {
        console.log(err)
      }
    })
  }
}
